import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Cookies } from "react-cookie";
import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";

export const dashboardSocietyCount = createAsyncThunk(
  "dashboardSocietyCount",
  async () => {
    try {
      const cookies = new Cookies();
      const token = cookies.get("token");

      const response = await AxiosInstance.get(`${API_KEY}/api/dashboard/counts`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data.message;
      } else {
        throw error;
      }
    }
  }
);

const initialState = {
  isLoading: false,
  dashboardSocietyCountData: null,
  isError: false,
  errorMessage: "",
};

const dashboardSocietyCountSlice = createSlice({
  name: "dashboardSocietyCount",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(dashboardSocietyCount.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(dashboardSocietyCount.fulfilled, (state, action) => {
      state.isLoading = false;
      state.dashboardSocietyCountData = action.payload;
    });
    builder.addCase(dashboardSocietyCount.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default dashboardSocietyCountSlice.reducer;
